import type { ReactNode } from 'react'
import { useQuery } from '@tanstack/react-query'
import { settingsApi } from '../../api/settings.api'
import { BrandMark } from '../../components/layout/BrandMark'
import { Mascot } from '../../components/brand/Mascot'
import styles from './AuthLayout.module.css'

export function AuthLayout({ children }: { children: ReactNode }) {
  const { data } = useQuery({
    queryKey: ['settings', 'general'],
    queryFn: async () => (await settingsApi.get()).data,
    staleTime: 60_000,
  })

  return (
    <div className={styles.wrap}>
      <div className={styles.card}>
        <div className={styles.illustration}>
          <div className={styles.lampCord} />
          <div className={styles.lampShade} />
          <div className={styles.lampGlow} />
          <div className={styles.mascotWrap}>
            <Mascot size={104} />
          </div>
          <div className={styles.illustrationCaption}>
            <span className={styles.illustrationTitle}>{data?.appName ?? 'City Survival'}</span>
            <span className={styles.illustrationTagline}>Euer Dev-Team-Panel für die Stadt.</span>
          </div>
        </div>
        <div className={styles.formPanel}>
          <div className={styles.brand}>
            <BrandMark logoUrl={data?.logoUrl} className={styles.brandMark} />
            <span className={styles.brandName}>{data?.appName ?? 'NTL Dashboard'}</span>
          </div>
          {children}
        </div>
      </div>
    </div>
  )
}
